import { useState } from "react";
import { Toaster } from "react-hot-toast";
import { ThemeProvider } from "styled-components";
import Modal from "react-modal";

import { AppContextProvider } from "./scripts/context";
import LPStake from "./pages/Stake";

import Navbar from "./components/Navbar";
import { DARK_THEME, LIGHT_THEME } from "./scripts/theme";

import "bootstrap-grid-only-css/dist/css/bootstrap-grid.min.css";
import "rc-tooltip/assets/bootstrap.css";

import GlobalStyles from "./scripts/globalStyles";

Modal.setAppElement("body");

export default function App() {
  const [theme, setTheme] = useState(localStorage.theme || "dark");

  function isMobileDevice() {
    return "ontouchstart" in window || "onmsgesturechange" in window;
  }

  // if (!window.ethereum && isMobileDevice()) {
  //   return (
  //     <div className="open-metamasl-mobile">
  //       <GlobalStyles theme={theme === "dark" ? DARK_THEME : LIGHT_THEME} />
  //       <div>
  //         <button
  //           onClick={() => {
  //             window.open(
  //               `https://metamask.app.link/dapp/${
  //                 window.location.origin.split("//")[1]
  //               }`
  //             );
  //           }}
  //         >
  //           Open MetaMask
  //         </button>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <ThemeProvider theme={theme === "dark" ? DARK_THEME : LIGHT_THEME}>
      {/* <div className="container">
          <div> */}

      {/* <img src="/img/under-maintenance.png" style={{ width: "100%" }} /> */}
      {/* </div>
      </div> */}
      <AppContextProvider theme={theme} setTheme={setTheme}>
        <Toaster position="top-right" reverseOrder={false} />
        <Navbar />
        <div className="pages-top-margin">
          <LPStake />
        </div>
      </AppContextProvider>
    </ThemeProvider>
  );
}
